function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Payments-Flow",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Payments---transactions",
  transform: "translate(-1252.000000, -175.000000)",
  fill: "#637280",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-8",
  transform: "translate(1231.000000, 69.000000)"
}, React.createElement("g", {
  id: "Group-11"
}, React.createElement("g", {
  id: "Group-6",
  transform: "translate(21.000000, 106.000000)"
}, React.createElement("path", {
  d: "M4.97777778,12.1333333 C5.49324354,12.1333333 5.91111111,12.5512009 5.91111111,13.0666667 C5.91111111,13.5821324 5.49324354,14 4.97777778,14 L2.28148148,14 C1.02145405,14 0,12.9785459 0,11.7185185 L0,2.28148148 C0,1.02145405 1.02145405,0 2.28148148,0 L4.97777778,0 C5.49324354,0 5.91111111,0.417867567 5.91111111,0.933333333 C5.91111111,1.4487991 5.49324354,1.86666667 4.97777778,1.86666667 L2.28148148,1.86666667 C2.05238559,1.86666667 1.86666667,2.05238559 1.86666667,2.28148148 L1.86666667,11.7185185 C1.86666667,11.9476144 2.05238559,12.1333333 2.28148148,12.1333333 L4.97777778,12.1333333 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M10.5022896,8.03703704 L4.66666667,8.03703704 C4.1512009,8.03703704 3.73333333,7.61916947 3.73333333,7.1037037 C3.73333333,6.58823794 4.1512009,6.17037037 4.66666667,6.17037037 L10.5022896,6.17037037 L8.72521886,4.39329966 C8.36072952,4.02881032 8.36072952,3.43785634 8.72521886,3.073367 C9.0897082,2.70887767 9.68066218,2.70887767 10.0451515,3.073367 L13.4155219,6.44373737 C13.7800112,6.80822671 13.7800112,7.39918069 13.4155219,7.76367003 L10.0451515,11.1340404 C9.68066218,11.4985297 9.0897082,11.4985297 8.72521886,11.1340404 C8.36072952,10.7695511 8.36072952,10.1785971 8.72521886,9.81410774 L10.5022896,8.03703704 Z",
  id: "Combined-Shape"
}))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/logout.4b6ceeaf.svg";
export { SvgComponent as ReactComponent };